import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Carlos M.',
    location: 'Miami, FL',
    quote: 'Estaba ahogado en impuestos y mezclando mi dinero personal con el del negocio. Este libro me dio el paso a paso para estructurar mi LLC y hoy tengo $30k en crédito comercial.',
    initials: 'CM',
    color: 'from-blue-500 to-navy',
    photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=face'
  }, {
    name: 'María G.',
    location: 'Houston, TX',
    quote: 'Pensé que por tener ITIN no podía acceder a capital. El módulo de crédito business me abrió los ojos. Ya aprobé mi primera tarjeta corporativa sin garantía personal.',
    initials: 'MG',
    color: 'from-gold to-gold-dark',
    photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop&crop=face'
  }, {
    name: 'Roberto S.',
    location: 'Los Angeles, CA',
    quote: 'La mejor inversión que he hecho. Solo el script de negociación bancaria vale miles. Fui al banco con confianza y salí con una línea de crédito aprobada.',
    initials: 'RS',
    color: 'from-gray-700 to-gray-900',
    photo: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=200&h=200&fit=crop&crop=face'
  }];
  return <section className="py-8 md:py-14 bg-gradient-to-b from-slate-50 to-slate-100" data-id="element-165">
      <div className="max-w-6xl mx-auto px-4" data-id="element-166">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-167">
          <h2 className="text-3xl md:text-4xl text-navy mb-4" data-id="element-168">
            ¿Qué Dicen Nuestros Alumnos?
          </h2>
          <div className="w-20 h-1 bg-gold mx-auto rounded-full" data-id="element-169" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-170">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="bg-white p-8 rounded-xl shadow-lg border border-slate-200 flex flex-col" data-id="element-171">
              <div className="flex gap-1 mb-6" data-id="element-172">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-173" />)}
              </div>

              <p className="text-gray-700 font-body italic mb-8 flex-1 text-lg" data-id="element-174">
                "{t.quote}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-175">
                <div className="relative w-12 h-12 rounded-full overflow-hidden ring-2 ring-gold/30 shadow-md flex-shrink-0" data-id="element-176">
                  <img src={t.photo} alt={t.name} className="w-full h-full object-cover" loading="lazy" data-id="element-177" />
                </div>
                <div data-id="element-178">
                  <h4 className="font-heading font-bold text-navy" data-id="element-179">{t.name}</h4>
                  <p className="text-sm text-gray-500" data-id="element-180">{t.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}